import { ClientFactory, ProjectClient } from '@contentsquare/uxanalytics-client';
import { defineCustomElements } from '@cs-materials/common/loader';
import { AppContext, Token, AppContextFactory, ResourceService } from '@uxanalytics/core';
import Vue from 'vue';
import App from './App.vue';
import { config } from './services/config.service';
import { MicroApps } from './services/micro-apps.service';
import { formatAnalysisContext } from './services/request.formatter';

Vue.config.productionTip = false;

const JWT_KEY = 'jwtToken';
const TIMEZONE_KEY = 'timezoneId';
const DEFAULT_TIMEZONE = 'Etc/UTC';
const CURRENCY_KEY = 'currency';

async function fetchCurrency(projectId: string) {
  const projectClient: ProjectClient = ClientFactory.get(ProjectClient as any);
  const project = await projectClient.get(+(projectId as any));
  if (!project?.currency) {
    throw new Error('no currency setup for this project');
  }
  return project.currency;
}

(async () => {
  console.log('CS-Live merchandising panel start');
  window.addEventListener('message', (msg: MessageEvent) => {
    if (msg.data.token) {
      const localStorageToken = localStorage.getItem(JWT_KEY);
      if (localStorageToken !== msg.data.token) {
        localStorage.setItem(JWT_KEY, msg.data.token);
        // move to url query
        localStorage.setItem(TIMEZONE_KEY, msg.data.timezone || DEFAULT_TIMEZONE);
        window.location.reload();
      }
    }
    if (msg.data.context) {
      const project = formatAnalysisContext(msg.data.context).project;
      (window as any).App.projectId = project;
    }
  });
  const urlParams = new URLSearchParams(window.location.search);
  const jwtToken = localStorage.getItem(JWT_KEY);

  if (!jwtToken) {
    return;
  }
  const url = urlParams.get('apiUrl') ?? config.apiUrl;
  Object.assign(config, { apiUrl: url });
  ClientFactory.init({
    url,
    token: { jwtToken },
  });

  const projectId = urlParams.get('project');
  if (!projectId) {
    throw new Error('ProjectId is needed for initialise');
  }

  const currency =
    urlParams.get(CURRENCY_KEY) ?? localStorage.getItem(CURRENCY_KEY) ?? (await fetchCurrency(projectId));
  localStorage.setItem(CURRENCY_KEY, currency);

  (window as any).App = {
    ...config,
    user: {
      timezoneId: localStorage.getItem(TIMEZONE_KEY) || DEFAULT_TIMEZONE,
      currency,
      locale: config.locale,
    },
    timezoneId: localStorage.getItem(TIMEZONE_KEY) || DEFAULT_TIMEZONE,
    currency,
  };

  const token = new Token(jwtToken);
  await AppContextFactory.loadContext(
    new AppContext(
      +(projectId as any),
      { ...config, currency: currency || 'EUR' } as any,
      token,
      {} as any,
      new ResourceService([]),
    ),
  );
  await MicroApps.install();

  defineCustomElements(window);

  new Vue({
    render: h => h(App),
  }).$mount('#app');
})();
